import { mapCollection } from '../../utils/collection.utils';
import { Target } from '../target';

export class TargetBuilder {
  static fromJson(json) {
    return (json)
      ? new Target(
        json.hash,
        json.title
      )
      : null;
  }

  static fromList(list) {
    return (Array.isArray(list)) ? mapCollection(TargetBuilder.fromJson, list) : [];
  }
}
